import { getEgresoDrops, createEgresoDrop, updateEgresoDrop, deleteEgresoDrop } from '../models/egresoDropModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

// Retry utility function
async function retryRequest(fn, maxRetries = 3, delay = 1000) {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      console.warn(`Attempt ${i + 1} failed:`, error.message);
      if (i === maxRetries - 1) throw error;
      await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
    }
  }
}

// Cargar los drops de un egreso
export async function fetchEgresoDrops(egresoCabId) {
  try {
    const response = await retryRequest(() => getEgresoDrops(egresoCabId, 1, 100));
    return response.items || [];
  } catch (error) {
    console.error("Error fetching egresoDrops:", error);
    // Don't show error modal for individual requests to avoid spam
    return [];
  }
}

// Guardar o actualizar un drop de egreso
export async function saveEgresoDrop(egresoDrop, currentEgresoDropId) {
  try {
    let result;
    if (currentEgresoDropId) {
      result = await updateEgresoDrop(currentEgresoDropId, egresoDrop);
      toasts.add({
        title: 'Éxito',
        description: 'Drop de egreso actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      result = await createEgresoDrop(egresoDrop);
      toasts.add({
        title: 'Éxito',
        description: 'Drop de egreso creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
    return result;
  } catch (error) {
    console.error("Error saving egresoDrop:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el drop de egreso',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
    throw error;
  }
}

// Eliminar un drop de egreso
export async function removeEgresoDrop(id) {
  try {
    await deleteEgresoDrop(id);
    toasts.add({
      title: 'Éxito',
      description: 'Drop de egreso eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting egresoDrop:", error);
    Swal.fire('Error', 'No se pudo eliminar el drop de egreso', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'egresoDrop'
export function subscribeToEgresoDrops(handleSearch) {
  pb.collection('egresoDrop').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromEgresoDrops() {
  pb.collection('egresoDrop').unsubscribe('*');
}

// Buscar drops de egreso por referencia con paginación
export async function searchEgresoDrops(query, egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDrop').getList(page, perPage, {
      filter: `(target_ref ~ "${query}" || delivery_ref ~ "${query}" || transporte_ref ~ "${query}") && egresoCab = "${egresoCabId}"`,
      expand: "delivery,vehiculo,transporte"
    });
    return {
      egresoDrops: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoDrops:", error);
    Swal.fire('Error', 'No se pudo realizar la búsqueda de drops de egreso', 'error');
    return null;
  }
} 